module.exports = __webpack_public_path__ + "img/doctor.286f8e55.png";